import type { FragmentType } from '@packages/gql/generated/shopping';
import type { CustomerReviewTagFragmentFragmentDoc } from '@packages/gql/generated/shopping/CustomerReviewTagFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';

/* GraphQL */ `
  fragment CustomerReviewTagFragment on ReviewTag {
    id
    name
  }
`;

export type CustomerReviewTagsProps = {
  /**
   * data - the data needed to render the component
   */
  data: Array<FragmentType<typeof CustomerReviewTagFragmentFragmentDoc>>;
  /**
   * label - the label that is placed before the tags
   */
  label: string;
};

/**
 * The CustomerReviewTags component displays the review pro and/or contra tags
 */
export const CustomerReviewTags = ({ data, label }: CustomerReviewTagsProps) => {
  const unmaskedData = unmask<typeof CustomerReviewTagFragmentFragmentDoc>(data);

  return (
    <div className="text-size-body-sm">{`${label} ${unmaskedData.map((tag) => tag.name).join(', ')}`}</div>
  );
};
